// extracted by mini-css-extract-plugin
export default {"auth":"auth_auth__xhnLh","copyright":"auth_copyright__z0GcN","roles":"auth_roles__jlIAr","bg":"auth_bg__AhHbb"};